import React from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className={`relative inline-flex items-center justify-center p-2 rounded-lg transition-all duration-300 focus:outline-none ${theme === 'dark'
                    ? 'bg-gray-800 text-yellow-400 hover:bg-gray-700'
                    : 'bg-orange-100 text-orange-500 hover:bg-orange-200'
                }`}
            aria-label="Toggle Dark Mode"
        >
            <div className="relative w-5 h-5 overflow-hidden">
                <FaSun
                    className={`absolute inset-0 w-full h-full transform transition-transform duration-500 ease-in-out ${theme === 'dark' ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
                        }`}
                />
                <FaMoon
                    className={`absolute inset-0 w-full h-full transform transition-transform duration-500 ease-in-out ${theme === 'dark' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
                        }`}
                />
            </div>
        </button>
    );
};

export default ThemeToggle;
